export const getQueryKeyFromParams = (params: Record<string, unknown>) => [
	...Object.entries(params).sort()
];
